import script from "./Template-003.vue?vue&type=script&lang=ts&setup=true"
export * from "./Template-003.vue?vue&type=script&lang=ts&setup=true"

import "./Template-003.vue?vue&type=style&index=0&id=0ec79716&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ec79716"]])

export default __exports__